import { reactive } from 'vue'

export const appConfig = reactive({
  isShowLeft: true,
})
